import { Box, Text, VStack } from '@bpba/ui-components';
import { GenericCard } from '@bpba/modules-components';
import { ProductoData } from '../../model/ProductoData';
import { IIndexable } from '../../model/IIndexable';
import { TagDescuento } from './TagDescuento';
import { NumberFormat } from '../../config/NumberFormat';
import styled from 'styled-components';
import { LayoutProps, layout } from 'styled-system';
import { PointsComponent } from '../shared/PointsComponent';

type ProductoProps = {
  data: ProductoData;
  width: IIndexable;
  isLast: boolean;
  id?: string;
};
export const Producto = ({ data, width, isLast, id }: ProductoProps) => {
  const puntosAriaLabel = data?.puntos ? NumberFormat.formatNumber(data.puntos) + ' puntos.' : '';
  const tituloAriaLabel = data.titulo ?? '';
  const rubroAriaLabel = data?.rubroTitle ? '. Rubro: ' + data.rubroTitle : '';
  const ariaLabel = `${puntosAriaLabel} ${tituloAriaLabel}${rubroAriaLabel}`;

  return (
    <>
      <GenericCard
        borderTopLeftRadius="8px"
        borderTopRightRadius={['16px', '24px']}
        borderBottomLeftRadius={['16px', '24px']}
        borderBottomRightRadius="8px"
        height={['190px', '400px']}
        marginBottom={['16px', '32px']}
        marginRight={isLast ? '0px' : '16px'}
        isLast={false}
        flexDirection={['row-reverse', 'column']}
        flexWrap={'wrap'}
        data={data}
        width={width}
        maxWidth={['unset', '230px']}
        id={id}
      >
        <Box
          display="flex"
          justifyContent={'center'}
          margin={'0'}
          padding={'0'}
          height={['100%', '50%']}
          width={['50%', '100%']}
          overflow={'hidden'}
          backgroundColor={'white'}
        >
          <StyledImg alt="" src={data.imagenes?.[0]?.trim()} />
          <TagDescuento texto={data.descuento} />{' '}
        </Box>
        <Box
          backgroundColor="white"
          display="flex"
          flexDirection="column"
          justifyContent={['space-between']}
          width={['50%', '100%']}
          p={['24px']}
          height={['100%', '50%']}
          alignItems="stretch"
          aria-label={ariaLabel}
        >
          <VStack>
            <PointsComponent product={data} fontSize={['20px', '24px']} margin="0 0 16px" />
            <StyledText fontSize={['14px', '15px']} marginBottom={'0px'} marginTop={'0px'} maxHeight={[88, 96]} overflow="hidden">
              {data.titulo}
            </StyledText>
          </VStack>

          <Text fontSize={'14px'} color={'tertiary.0'} fontWeight={500} marginBottom={'0px'}>
            {data.rubroTitle?.toUpperCase()}
          </Text>
        </Box>
      </GenericCard>
    </>
  );
};

const StyledImg = styled.img({ objectFit: 'contain', width: '100%', height: '100%' });

const StyledText = styled(Text)<LayoutProps>(layout);
